/* eslint-disable no-console */

export function warningBanner(message: string, char = '-'): void {
  message = `| ${message} |`;
  console.log(char.repeat(message.length));
  console.log(message);
  console.log(char.repeat(message.length));
}
